import { useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { useQueryClient } from '@tanstack/react-query';
import { Api, ApiError } from '@/core/api';

const ERR_FA: Record<string, string> = {
  SHARE_CODE_NOT_FOUND: 'چنین کدی نداریم. حروف را دوباره نگاه کنید.',
  SHARE_CODE_USED: 'این کد قبلاً استفاده شده. از خانواده کد تازه بخواهید.',
  SHARE_CODE_EXPIRED: 'این کد منقضی شده. از خانواده کد تازه بخواهید.',
  SHARE_CODE_OWN: 'این کد مال پروفایل خودتان است.',
};

export function RedeemPage() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const go = async () => {
    setBusy(true);
    setErr(null);
    try {
      const r = await Api.redeem(code.trim());
      await qc.invalidateQueries({ queryKey: ['profiles'] });
      await navigate({ to: '/p/$id', params: { id: r.profileId } });
    } catch (e) {
      setErr(e instanceof ApiError ? (ERR_FA[e.code] ?? e.code) : 'خطا');
    } finally {
      setBusy(false);
    }
  };
  return (
    <main className="page">
      <h1 className="page-title">کد اشتراک</h1>
      <section className="card">
        <p className="help">
          کدی که خانواده به شما داده را وارد کنید. دسترسی شما به همان شاخه‌هایی است که خانواده
          انتخاب کرده.
        </p>
        <label className="field">
          <span>کد ۸ حرفی</span>
          <input
            className="input machine"
            style={{ letterSpacing: 4, textTransform: 'uppercase' }}
            value={code}
            onChange={(e) => setCode(e.target.value)}
            autoFocus
          />
        </label>
        {err && <div className="error">{err}</div>}
        <button
          type="button"
          className="btn primary block"
          disabled={busy || code.replace(/\s/g, '').length < 6}
          onClick={go}
        >
          ورود به پروفایل
        </button>
      </section>
    </main>
  );
}
